var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "success-style", attrs: { id: "verifySucceeded" } },
    [
      _vm.activeType == "setAccount" || _vm.activeType == "upAccount"
        ? [
            _c("div", { staticClass: "y-mt-30 y-f y-f-jc y-f-a" }, [
              _c("img", {
                staticClass: "success-icon y-mr-10",
                attrs: {
                  slot: "reference",
                  src: require("@/assets/images/icon_success@2x.png"),
                },
                slot: "reference",
              }),
              _c("span", { staticClass: "success-tip" }, [_vm._v("验证成功")]),
            ]),
            _c("div", { staticClass: "y-mt-25 y-f y-f-jc" }, [
              _vm.activeType == "setAccount"
                ? _c("span", { staticClass: "success-info" }, [
                    _vm._v("未设置收款账号，请前往支付宝进行授权"),
                  ])
                : _vm._e(),
              _vm.activeType == "upAccount"
                ? _c("span", { staticClass: "success-info" }, [
                    _vm._v("修改收款账号，请前往支付宝进行授权"),
                  ])
                : _vm._e(),
            ]),
            _c(
              "div",
              { staticClass: "y-mt-40 y-f y-f-jc" },
              [
                _c(
                  "el-button",
                  { staticClass: "y-w-100", on: { click: _vm.close } },
                  [_vm._v("取消")]
                ),
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.toAlipay } },
                  [_vm._v("去授权支付宝账号")]
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
      _vm.activeType == "showAccount"
        ? [
            _c("div", { staticClass: "y-mt-30 y-f y-f-jc y-f-a" }, [
              _c("img", {
                staticClass: "success-icon y-mr-10",
                attrs: {
                  slot: "reference",
                  src: require("@/assets/images/icon_success@2x.png"),
                },
                slot: "reference",
              }),
              _c("span", { staticClass: "success-tip" }, [
                _vm._v("收款账号设置成功"),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "y-mt-40 y-f y-f-jc" },
              [
                _c(
                  "el-button",
                  { staticClass: "y-w-100", on: { click: _vm.close } },
                  [_vm._v("我知道了")]
                ),
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.toSetting } },
                  [_vm._v("查看收款账号")]
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
      _vm.activeType == "unBindAccount"
        ? [
            _c("div", { staticClass: "y-mt-30 y-f y-f-jc y-f-a" }, [
              _c("img", {
                staticClass: "success-icon y-mr-10",
                attrs: {
                  slot: "reference",
                  src: require("@/assets/images/icon_success@2x.png"),
                },
                slot: "reference",
              }),
              _c("span", { staticClass: "success-tip" }, [
                _vm._v("收款账号解绑成功"),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "y-mt-40 y-f y-f-jc" },
              [
                _c(
                  "el-button",
                  { staticClass: "y-w-100", on: { click: _vm.close } },
                  [_vm._v("我知道了")]
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
      _vm.activeType == "errorAccount"
        ? [
            _c("div", { staticClass: "y-mt-30 y-f y-f-jc y-f-a" }, [
              _c("img", {
                staticClass: "success-icon y-mr-10",
                attrs: {
                  slot: "reference",
                  src: require("@/assets/images/icon_error@2x.png"),
                },
                slot: "reference",
              }),
              _c("span", { staticClass: "success-tip" }, [_vm._v("验证失败")]),
            ]),
            _c(
              "div",
              { staticClass: "y-mt-40 y-f y-f-jc" },
              [
                _c(
                  "el-button",
                  { staticClass: "y-w-100", on: { click: _vm.close } },
                  [_vm._v("取消")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "y-w-100",
                    attrs: { type: "primary" },
                    on: { click: _vm.toSetting },
                  },
                  [_vm._v("重新验证")]
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }